import { DISCOUNT_TYPES } from '../../stores/promoCodeStore/promoCode.consts'
import { type Coupon } from '../../stores/promoCodeStore/promoCode.types'
import { formatPrice } from '../../utils/utils'
import { translateManager as t } from '../../services/TranslateManager'
import { isBookGiftCard } from '../../stores/promoCodeStore/promoCode.utils'

type GiftCardMetadata = {
  remainingValue?: number
  currency?: string
  tileSizesList?: string[]
  [key: string]: unknown
}

function getGiftCardValue(coupon: Coupon): string {
  if (coupon.discountType === DISCOUNT_TYPES.GIFT_CARD) {
    const metadata = coupon.metadata as GiftCardMetadata | undefined
    return formatPrice(
      metadata?.remainingValue ?? 0,
      metadata?.currency ?? 'USD'
    )
  }

  const amount = coupon.amount ?? 0
  const metadata = coupon.metadata as GiftCardMetadata | undefined
  const tileSizesList = metadata?.tileSizesList
  const isBook = isBookGiftCard(tileSizesList)

  if (isBook) {
    return amount > 1
      ? t.get(
          'general.promo_code_success_dialog.subtitle.gift_card_books_many',
          { v1: amount }
        )
      : t.get('general.promo_code_success_dialog.subtitle.gift_card_books_one')
  } else {
    return amount > 1
      ? t.get(
          'general.promo_code_success_dialog.subtitle.gift_card_tiles_many',
          { v1: amount }
        )
      : t.get('general.promo_code_success_dialog.subtitle.gift_card_tiles_one')
  }
}

export function getGiftCardDialogSubtitle(coupon: Coupon): string {
  const giftCardValue = getGiftCardValue(coupon)
  return t.get('general.promo_code_success_dialog.subtitle.gift_card', {
    v1: giftCardValue,
  })
}

export function getGiftCardDialogText(coupon: Coupon): {
  title: string
  subtitle: string
} {
  return {
    title: t.get('general.promo_code_success_dialog.title.gift_card'),
    subtitle: getGiftCardDialogSubtitle(coupon),
  }
}
